module.exports = __webpack_public_path__ + "static/img/Fassadengestaltung1.42cc56f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/Fassadengestaltung1.jpg
// module id = 89q1
// module chunks = 1